/**
 * Drawer groups treated as unused for hosting/ops workflows.
 * Toggled via "Hide unused" in the sidemenu (drawer.hideUnused).
 */
export const DRAWER_UNUSED_GROUPS: string[] = [
  '/scrums',
  '/sms',
  '/ipset',
  '/qc',
  '/qc-settings',
  '/qc-v2',
  '/qc-settings-v2',
  '/dossiers',
  '/internal-tickets',
  '/files-manager',
];

export function isUnusedDrawerGroup(group: string | undefined): boolean {
  if (!group) {
    return false;
  }
  return DRAWER_UNUSED_GROUPS.indexOf(group) !== -1;
}
